export const clientSoftwareCopy = {
    pageDescription: (
        <div style={{ maxWidth: '70ch' }}>
            <p>
                Each row represents an identity that a requester has claimed to have via
                headers. Anyone can make a claim, with the exception of the{' '}
                <code>AnalyticsModel</code> category, which requires a claimant to have
                Global Admin permission level to show up here.
            </p>
            <p>
                Modifications to <strong>Tags</strong> here modify application behavior.
                Change only if you know what you are doing.
            </p>
        </div>
    ),
    tagsBehavior: <span></span>,
    columns: {
        name: (
            <span>The client&apos;s claimed name. (more specific than API Client)</span>
        ),
        apiClient: <span>The client&apos;s claimed type.</span>,
        knownClient: (
            <span>
                Same as API Client, but populated only if the the backend recognizes this
                client type.
            </span>
        ),
        description: <span>A human-friendly description, populated via this page.</span>,
        tags: (
            <span>
                Tags which may govern how SMARTdiagnostics treats clients with the tag.
            </span>
        ),
    },
};
